import { SellerFilter, MarketplaceFilter, CategoryFilter } from "@/components/new-filters";
import { mapState } from 'vuex';
import FiltersFrame from "@/components/new-filters/FiltersFrame.vue";
import { EVENTS } from "@/utils";
export default {
  name: "MarketInsightsFilters",
  components: {
    SellerFilter,
    MarketplaceFilter,
    FiltersFrame,
    CategoryFilter
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.market_insights.sellers_filter,
      marketplaces_filter: state => state.market_insights.marketplaces_filter,
      categories_filter: state => state.market_insights.categories_filter
    })
  },
  methods: {
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for sellers...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS_SELLERS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        await window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS_MARKETPLACES_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS);
      }
    },
    applyCategories() {
      if (this.categories_filter.isModified) {
        this.categories_filter.apply();
        window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS);
      }
    }
  }
};